"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressHelpers = void 0;
class ProgressHelpers {
    static findFlatSectionByProgress(flatSections, section) {
        if (!section) {
            return flatSections[0] || null;
        }
        return flatSections.find(s => Number(s.sectionId) === Number(section.id)) || flatSections[0] || null;
    }
    static countDoneTodoItems(todo) {
        if (!todo) {
            return { done: 0, total: 0 };
        }
        if (todo.items && todo.items.length > 0) {
            const done = todo.items.filter((item) => item.done).length;
            return { done, total: todo.items.length };
        }
        return { done: todo.done ? 1 : 0, total: 1 };
    }
    static calculateSectionProgress(section) {
        if (!section) {
            return { done: 0, total: 0 };
        }
        const todos = section.tutorialSectionTodos || [];
        if (todos.length === 0) {
            return { done: 1, total: 1 };
        }
        const allTodosDone = todos.every((sectionTodo) => {
            const todo = sectionTodo.todo;
            if (!todo) {
                return false;
            }
            if (todo.items && todo.items.length > 0) {
                return todo.items.every((item) => item.done);
            }
            return todo.done;
        });
        return { done: allTodosDone ? 1 : 0, total: 1 };
    }
    static calculateStepProgress(step) {
        if (!(step === null || step === void 0 ? void 0 : step.tutorialSections)) {
            return { done: 0, total: 0 };
        }
        let done = 0;
        let total = 0;
        step.tutorialSections.forEach((section) => {
            const sectionProgress = this.calculateSectionProgress(section);
            done += sectionProgress.done;
            total += sectionProgress.total;
        });
        return { done, total };
    }
    static calculateTutorialProgressFromTodos(tutorial) {
        if (!(tutorial === null || tutorial === void 0 ? void 0 : tutorial.tutorialSteps)) {
            return { doneCount: 0, totalCount: 0 };
        }
        let doneCount = 0;
        let totalCount = 0;
        tutorial.tutorialSteps.forEach((step) => {
            const stepProgress = this.calculateStepProgress(step);
            doneCount += stepProgress.done;
            totalCount += stepProgress.total;
        });
        return { doneCount, totalCount };
    }
}
exports.ProgressHelpers = ProgressHelpers;
